import { createApi } from '@reduxjs/toolkit/dist/query/react'
import baseQueryWithReauth from '../../app/baseQueryWithOnlineCourse'
import { CourseUserDetailState, CourseUserState } from '../types'

export const courseUserApiSlice = createApi({
    reducerPath: 'courseUserApi',
    baseQuery: baseQueryWithReauth,
    tagTypes: ['Student', 'CoursesOfUser'],
    endpoints: (build) => ({
        createCourseStudent: build.mutation<void, CourseUserState>({
            query: (courseUser) => ({
                url: 'user-course',
                method: 'POST',
                body: courseUser,
            }),
            invalidatesTags: [{ type: 'Student', id: 'LIST' }],
        }),

        addCourseStudent: build.mutation<void, any>({
            query: (params) => ({
                url: `user-course/${params.userId}`,
                method: 'POST',
                body: params.body,
            }),
            invalidatesTags: [{ type: 'CoursesOfUser', id: 'LIST' }],
        }),

        updateCourseStudent: build.mutation<void, any>({
            query: (courseUser) => ({
                url: `user-course/${courseUser.id}`,
                method: 'PUT',
                body: courseUser,
            }),
            invalidatesTags: [{ type: 'CoursesOfUser', id: 'LIST' }],
        }),

        deleteStudentFromCourse: build.mutation<any, number>({
            query: (id) => ({
                url: `user-course/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, id) => [
                { type: 'CoursesOfUser', id },
            ],
        }),

        getCourseUsersInfo: build.mutation<
            Array<CourseUserDetailState>,
            Array<number>
        >({
            query: (userIds) => ({
                url: `user-course/data`,
                method: 'POST',
                body: userIds,
            }),
            transformResponse: (response: any) => response.data,
        }),

        getCoursesOfUser: build.query<any, number>({
            query: (userId) => ({
                url: `user-course/get-by-user/${userId}`,
            }),
            providesTags: (result) =>
                result
                    ? [
                          ...result.map(({ id }) => ({
                              type: 'CoursesOfUser' as const,
                              id,
                          })),
                          { type: 'CoursesOfUser', id: 'LIST' },
                      ]
                    : [{ type: 'CoursesOfUser', id: 'LIST' }],
            transformResponse: (response: any) => response.data,
        }),
    }),
})
